import moment from 'moment';
import { Subscription } from '../types/user';

export const getExpirationDateMessage = (expirationDate: string) => {
  let endingText = '.';
  const formattedDate = moment(expirationDate, 'DD/MM/YYYY');
  if (!expirationDate.includes('9999') && formattedDate.isValid()) {
    endingText = ` até ${formattedDate.format('DD/MM/YYYY')}`;
  }
  return `Sua assinatura é válida${endingText}`;
};

export function separateSubscriptionsByProvider(
  subscriptionData: Subscription,
  SalesForce: string,
) {
  const salesForceSignatures = subscriptionData.signatures.filter(
    signature => signature.provider === SalesForce,
  );
  const editoraSignatures = subscriptionData.signatures.filter(
    signature => signature.provider !== SalesForce,
  );

  return { salesForceSignatures, editoraSignatures };
}
